<template>
	<div class="c-governance-item-small" :class="contextClass" @click="handleDetail(itemData)">
		<div class="introduce-avatar" v-if="showAvatar && itemData.photo">
			<img :src="itemData.photo" alt="" />
		</div>
		<div class="introduce-info">
			<p class="introduce-info-name text-overflow">{{ itemData.name }}</p>
			<p class="introduce-info-position text-overflow" v-if="itemData.position">
				{{ itemData.position }}
			</p>
		</div>

		<CDialogCorporate v-if="visible" :visible.sync="visible" :memberInfo="memberInfo" />
	</div>
</template>

<script setup>
import CDialogCorporate from './CDialogCorporate.vue';
import { ref, computed } from 'vue';
import { useStore } from '@/utils/vue-api';
import instance from '@/axios';
import { enterprise } from '@/axios/interface';
import i18n, { languageTypeMap } from '@/locales';
import { useCurrentContext } from './context';

const props = defineProps({
	itemData: {
		type: Object,
		default: () => {}
	},
	memberStyle: {
		type: [Number, String],
		default: 1
	},
	showAvatar: {
		type: Boolean,
		default: true
	}
});

const context = useCurrentContext();
const useSlideMStyle = computed(() => context.useSlideMStyle);

const contextClass = computed(() => {
	if (useSlideMStyle.value) {
		return 'c-governance-item-bg-slideM';
	}
	return `c-governance-item-bg-${props.memberStyle}`;
});

const store = useStore();
const memberInfo = ref({});
const visible = ref(false);
const handleDetail = async info => {
	await getCorporateDetails(info.businessId);
	if (memberInfo.value.photo || memberInfo.value.abstractText) {
		visible.value = true;
	}
};
const getCorporateDetails = businessId => {
	const { storeId } = store.getters.getCommonData;
	return instance
		.get(enterprise.getCorporateDetails(storeId, businessId), { languageType: languageTypeMap[i18n.locale] })
		.then(({ data }) => {
			memberInfo.value = data?.data[0];
		})
		.catch(err => {
			console.log(err);
		})
		.finally(() => {});
};
</script>

<style lang="less" scoped>
.c-governance-item-small {
	display: flex;
	cursor: pointer;
	width: calc((100% - 32px) / 3);
	height: 88px;
	padding: 20px 16px;
	border-radius: 2px;
	border: 1px solid var(--border-lighter-color, #f2f3f5);
	background: url('~@/assets/images/home/corporate_bg.png') no-repeat;
	background-size: 100% 100%;

	margin-right: 16px;
	&:nth-child(3n) {
		margin-right: 0;
	}
	margin-top: 17px;
	&:nth-child(-n + 3) {
		margin-top: 0;
	}
	.introduce-avatar {
		width: 48px;
		height: 48px;
		margin-right: 12px;
		img {
			width: 100%;
			height: 100%;
			border-radius: 50%;
			object-fit: cover;
		}
	}

	.introduce-info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 0;
		flex: 1;

		&-name {
			color: #1d2129;
			text-align: justify;

			font-size: 16px;

			font-weight: 500;
			line-height: 24px; /* 150% */
		}
		&-position {
			margin-top: 8px;
			color: var(--t-secondary-info-color, #86909c);

			font-size: 12px;

			font-weight: 400;
			line-height: 16px; /* 133.333% */
		}
	}
}

.c-governance-item-bg-1 {
	background: url('~@/assets/images/home/corporate_bg1.png') no-repeat;
	background-size: 100% 100%;
}
.c-governance-item-bg-2 {
	background: url('~@/assets/images/home/corporate_bg2.png') no-repeat;
	background-size: 100% 100%;
}
.c-governance-item-bg-3 {
	background: url('~@/assets/images/home/corporate_bg3.png') no-repeat;
	background-size: 100% 100%;
}
.c-governance-item-bg-slideM {
	background: #fff;
}
</style>
